import React, { useState, useEffect } from 'react';
import { FaWhatsapp, FaInstagram, FaFacebook, FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from 'react-icons/fa';
import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import './fale_conosco.css';

const FaleConosco = () => {

  useEffect(() => {
    document.title = "Trinco | Fale com a Trinco";
  }, []);

  return (
    <>
      <div className="page-wrapper">
        <Header />
        <div className="fale-conosco-container">

          <section className="fale-hero">
            <h1>Fale com a Trinco</h1>
            <p>Escolha o canal de sua preferência e fale diretamente com nossa equipe.</p>
          </section>

          <div className="fale-content-center">

            {/* Lado Esquerdo: Canais de Conexão */}
            <div className="fale-info-grid">

              <div className="info-card">
                <h3>Canais Diretos</h3>
                <div className="contact-item">
                  <a
                    href="https://wa.me/5571999556884"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: 'flex', textDecoration: 'none', color: 'inherit', alignItems: 'center' }}
                  >
                    <FaWhatsapp className="icon-green" />
                    <div>
                      <strong>WhatsApp</strong>
                      <p>(71) 99955-6884</p>
                    </div>
                  </a>
                </div>
                <div className="contact-item">
                  <FaPhoneAlt className="icon-green" />
                  <div>
                    <strong>Telefone</strong>
                    <p>(71) 3014-6400</p>
                  </div>
                </div>
                <div className="contact-item">
                  <FaEnvelope className="icon-green" />
                  <div>
                    <strong>E-mail</strong>
                    <p>contato@trincoservicos.com.br</p>
                  </div>
                </div>
                <div className="contact-item">
                  <FaMapMarkerAlt className="icon-green" />
                  <div>
                    <strong>Nossas Unidades</strong>
                    <p>Estamos nos principais shoppings de Salvador-BA, Lauro de Freitas-BA e Feira de Santana-BA</p>
                  </div>
                </div>
              </div>

              <div className="info-card">
                <h3>Redes Sociais</h3>
                <p className="social-desc">Conteúdo, bastidores e novidades da Trinco em tempo real.</p>
                <div className="social-links">
                  <a href="https://www.instagram.com/trincoservicos" target="_blank" className="social-btn instagram"><FaInstagram /> Instagram @trincoservicos</a>
                  <a href="https://www.facebook.com/natrincotem" target="_blank" className="social-btn facebook"><FaFacebook /> Facebook /natrincotem</a>
                </div>
              </div>

            </div>

          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default FaleConosco;